// src/hooks/useStorage.js
import { useState, useCallback } from "react";

const PREFIX = "ipulse_";

export function useStorage(key, initialValue) {
  const fullKey = PREFIX + key;
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(fullKey);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = useCallback((value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(fullKey, JSON.stringify(valueToStore));
    } catch (err) {
      console.error("Storage error:", err);
    }
  }, [fullKey, storedValue]);

  return [storedValue, setValue];
}
